import React from "react";
import { Controller, FieldErrors, Control } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { SxProps, Theme } from "@mui/material";

export interface Option {
  value: string;
  label: string;
}

export interface SelectInputMultipleProps {
  fieldName: string;
  label: string;
  control: Control<any, any>;
  errors: FieldErrors<any>;
  options: Option[];
  fontSize?: number;
  width?: number | string;
  size?: "small" | "medium";
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
}

export function SelectInputMultiple(props: SelectInputMultipleProps) {
  const {
    sx,
    fieldName,
    control,
    fontSize,
    errors,
    width,
    label,
    options,
    ...otherProps
  } = props;
  const errorMessage = errors[fieldName]?.message as string | undefined;

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...otherProps}
          multiple
          options={options}
          getOptionLabel={(option: Option) => option.label}
          sx={{ ...sx }}
          renderInput={(params) => (
            <TextField
              {...params}
              style={props.style}
              size="small"
              sx={{
                // width: width ?? "200px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                },
              }}
              inputProps={{
                ...params.inputProps,
                style: {
                  fontSize: fontSize ?? 16,
                },
              }}
              InputLabelProps={{
                style: { fontSize: fontSize ?? 16 },
              }}
              label={label}
              error={!!errors[fieldName]}
              helperText={errorMessage}
            />
          )}
          value={field.value}
          onChange={(_, newValue: Option[]) => {
            field.onChange(newValue);
          }}
        />
      )}
    />
  );
}

export default SelectInputMultiple;
